import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import PracticeAreas from './components/PracticeAreas';
import Differentials from './components/Differentials';
import HowItWorks from './components/HowItWorks';
import CTASection from './components/CTASection';
import Contact from './components/Contact';
import Footer from './components/Footer';

const WA_LINK = 'https://wa.me/5511984333601?text=Ol%C3%A1%2C%20gostaria%20de%20falar%20com%20um%20especialista%20em%20direito%20imobili%C3%A1rio.';

export default function Home() {
  return (
    <div className="font-sans" style={{ background: '#F5F5F5' }}>
      <Navbar />
      <main>
        <Hero />
        <About />
        <PracticeAreas />
        <Differentials />
        <HowItWorks />
        <CTASection />
        <Contact />
      </main>
      <Footer />

      {/* Floating WhatsApp Button */}
      <a
        href={WA_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 flex items-center justify-center cursor-pointer transition-all duration-300 hover:scale-110"
        style={{ background: '#D4AF37', borderRadius: '50%' }}
        aria-label="Falar no WhatsApp"
        title="Falar no WhatsApp"
      >
        <i className="ri-whatsapp-line text-2xl" style={{ color: '#0A2A52' }}></i>
      </a>
    </div>
  );
}